@if (visivel) {
  <div class="iaa-painel" [class.iaa-aberto]="aberto">
    <div class="iaa-header">
      <div class="iaa-avatar">
        <span class="material-symbols-outlined">auto_awesome</span>
      </div>
      <div class="iaa-header-info">
        <span class="iaa-titulo">Assistente ATS</span>
        <span class="iaa-status"><span class="iaa-status-dot"></span>conectado ao seu ERP</span>
      </div>
      <button class="iaa-icone-btn" (click)="novaConversa()" title="Nova conversa">
        <span class="material-symbols-outlined">edit_square</span>
      </button>
      <button class="iaa-icone-btn" (click)="fechar()" title="Fechar">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <app-ia-chat
      class="iaa-chat"
      compacto
      [idConversa]="idConversa"
      [chips]="chips"
      [mostrarDisclaimer]="false"
      (idConversaChange)="onIdConversaChange($event)"
    ></app-ia-chat>
  </div>
}
